var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.projectId, staticClass: "project-detail-container" },
    [
      _c(
        "PageInfoHeader",
        {
          staticClass: "project-detail-header",
          attrs: {
            number: _vm.poNumber,
            description: _vm.projectName,
            shouldNavBack: _vm.pageInfoShouldNavBack,
            status: _vm.currentProjectStatus,
          },
        },
        [
          !_vm.isContractor
            ? _c("HKLHeader", {
                attrs: {
                  slot: "header-top",
                  "label-left-primary": _vm.projectHklLeftPrimaryLabel,
                  "link-class-left-primary": "back",
                  "label-right-leading": _vm.$t(
                    "listNavigation.previousRecord"
                  ),
                  "label-right-trailing": _vm.$t("listNavigation.nextRecord"),
                  "navigation-entries": _vm.projectListNavEntriesForHeader,
                  "current-record-id": _vm.projectHeaderCurrentRecordId,
                  "navigate-prev-enabled": _vm.isUnderBatch
                    ? _vm.canGoToPreviousWorkPermitRecord
                    : undefined,
                  "navigate-next-enabled": _vm.isUnderBatch
                    ? _vm.canGoToNextWorkPermitRecord
                    : undefined,
                },
                on: {
                  "left-primary": _vm.onProjectHklLeftPrimary,
                  "right-leading": _vm.onProjectHklPrevious,
                  "right-trailing": _vm.onProjectHklNext,
                },
                slot: "header-top",
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
            _c("div", { staticClass: "row" }, [_c("InviteBtn")], 1),
          ]),
          _vm._v(" "),
          _c("ProjectOptions", { attrs: { slot: "options" }, slot: "options" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "project-detail-wrapper" },
        [
          _vm.canProjectAccess
            ? _c("div", { staticClass: "project-po-info-wrapper" }, [
                _c(
                  "ul",
                  {
                    staticClass: "accordion accordion-customize",
                    attrs: {
                      id: "project-po-info",
                      "data-accordion": "",
                      "data-deep-link": "true",
                      "data-allow-all-closed": "true",
                      "data-multi-expand": "true",
                      "data-update-history": "true",
                      "data-deep-link-smudge": "500",
                    },
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "accordion-item is-active",
                        attrs: { "data-accordion-item": "" },
                      },
                      [
                        _c("a", { staticClass: "accordion-title" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("project.projectInfo"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "accordion-content",
                            attrs: { "data-tab-content": "" },
                          },
                          [
                            _c("div", { staticClass: "project-info" }, [
                              _c(
                                "div",
                                { staticClass: "row project-info-block" },
                                [
                                  _c("div", { staticClass: "small-12" }, [
                                    _c("label", { staticClass: "emphasis" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "project.purchaseOrder.vendorName"
                                          )
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.showAdminVendorHover
                                      ? _c("div", [
                                          _c(
                                            "p",
                                            [
                                              _c("HKLHoverTooltip", {
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href:
                                                                  "mailto:" +
                                                                  _vm
                                                                    .adminVendor
                                                                    .username,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.vendorName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                    {
                                                      key: "tips",
                                                      fn: function () {
                                                        return [
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.adminVendor.contacts.find(
                                                                  function (c) {
                                                                    return (
                                                                      c.type ===
                                                                      "NAME"
                                                                    )
                                                                  }
                                                                ).value
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href:
                                                                  "mailto:" +
                                                                  _vm
                                                                    .adminVendor
                                                                    .username,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .adminVendor
                                                                    .username
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.adminVendor.contacts.find(
                                                                  function (c) {
                                                                    return (
                                                                      c.type ===
                                                                      "PHONE_NUMBER"
                                                                    )
                                                                  }
                                                                ).value
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          !_vm.adminVendor
                                                            .enabled ||
                                                          !_vm.adminVendor
                                                            .invitedAt
                                                            ? _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "project.purchaseOrder.vendorNameTooltips"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3406144236
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _c("pre", [
                                          _c("p", [
                                            _vm._v(_vm._s(_vm.vendorName)),
                                          ]),
                                        ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small-12" },
                                    [
                                      _c("label", { staticClass: "emphasis" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "project.purchaseOrder.handledBy"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.showHandleByHover
                                        ? [
                                            _c(
                                              "HoverTooltip",
                                              {
                                                staticClass:
                                                  "info-hover-tool-tip",
                                                attrs: {
                                                  content:
                                                    _vm.hoverToolTipContent,
                                                  url: _vm.hoverToolTipMail,
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticStyle: {
                                                        "text-decoration":
                                                          "none",
                                                        color: "black",
                                                      },
                                                      attrs: {
                                                        href: _vm.hoverToolTipMail,
                                                        target: "_top",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.currentProject
                                                              .manager
                                                              .username || ""
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        : [
                                            _c("pre", [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.hoverToolTipContent
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small-4 medium-4 large-4" },
                                    [
                                      _c("label", { staticClass: "emphasis" }, [
                                        _vm._v(_vm._s(_vm.amountLabel) + ":"),
                                      ]),
                                      _vm._v(" "),
                                      _c("pre", [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                _vm.purchase.amount,
                                                {
                                                  currencyCode:
                                                    _vm.currencyCode,
                                                }
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small-4 medium-4 large-4" },
                                    [
                                      !_vm.isContractor ||
                                      _vm.deduction.amount > 0
                                        ? [
                                            _c(
                                              "label",
                                              { staticClass: "emphasis" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "project.deduction.label"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.isContractor &&
                                            !_vm.isProjectRepresentative
                                              ? _c("pre", [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatCurrency"
                                                        )(
                                                          _vm.deduction.amount,
                                                          {
                                                            currencyCode:
                                                              _vm.currencyCode,
                                                          }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "add-deduction-link",
                                                    attrs: {
                                                      slot: "activator",
                                                      id: "add-deduction",
                                                    },
                                                    slot: "activator",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        class: {
                                                          "link-clickable":
                                                            _vm.showDeductionLink,
                                                          "link-nonclickable":
                                                            !_vm.showDeductionLink,
                                                        },
                                                        on: {
                                                          click: function () {
                                                            return (
                                                              _vm.showDeductionLink &&
                                                              _vm.$refs.addDeductionModal.openModal()
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.deductionValue
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.isPicView && _vm.isOpen
                                                      ? _c("a", {
                                                          staticClass:
                                                            "fa fa-pencil icon",
                                                          on: {
                                                            click: function () {
                                                              return _vm.$refs.addDeductionModal.openModal()
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small-4 medium-4 large-4" },
                                    [
                                      _vm.deduction.amount > 0
                                        ? [
                                            _c(
                                              "label",
                                              { staticClass: "emphasis" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.revisedLabel) + ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("pre", [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatCurrency")(
                                                      _vm.purchase.amount -
                                                        _vm.deduction.amount,
                                                      {
                                                        force: true,
                                                        currencyCode:
                                                          _vm.currencyCode,
                                                      }
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small-12" },
                                    [
                                      _c("label", { staticClass: "emphasis" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "project.purchaseOrder.tenderNumber"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      !_vm.prNumber
                                        ? _c(
                                            "div",
                                            { staticClass: "tender-empty" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.$t("emptyValue")) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.prNumber
                                        ? _c("div", [
                                            _c("p", [
                                              _c(
                                                "a",
                                                {
                                                  class: {
                                                    "link-clickable":
                                                      _vm.showTender,
                                                    "link-nonclickable":
                                                      !_vm.showTender,
                                                  },
                                                  on: {
                                                    click: function () {
                                                      return (
                                                        _vm.showTender &&
                                                        _vm.navToTender()
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        #" +
                                                      _vm._s(_vm.prNumber) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.tenderAdditionalItems.length
                                        ? [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "emphasis additional-items",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "project.purchaseOrder.additionalItems"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "additional-items-list",
                                              },
                                              _vm._l(
                                                _vm.tenderAdditionalItems,
                                                function (item) {
                                                  return _c(
                                                    "li",
                                                    { key: item.name },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(item.key) +
                                                          ": " +
                                                          _vm._s(item.value) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "small-12" }, [
                                    _c("label", { staticClass: "emphasis" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("project.relatedProject")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.isEditRelated
                                      ? _c(
                                          "div",
                                          {
                                            ref: "projectRelatedRef",
                                            staticClass: "project-related",
                                          },
                                          [
                                            _vm._l(
                                              _vm.relatedProjects,
                                              function (item) {
                                                return _c(
                                                  "span",
                                                  { key: item.id },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "related-link no-underline",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getRelatedProjectsNumber(
                                                                item
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-times-thin",
                                                      on: {
                                                        click: function () {
                                                          return _vm.removeRelated(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.newPurchaseNumber,
                                                  expression:
                                                    "newPurchaseNumber",
                                                },
                                              ],
                                              staticClass:
                                                "related-project-number-input",
                                              class: {
                                                "error-highlight":
                                                  _vm.isInvalidNumber,
                                              },
                                              attrs: {
                                                id: "related-project-number-input",
                                                type: "text",
                                                placeholder: _vm.$t(
                                                  "project." +
                                                    _vm.numberType.toLowerCase() +
                                                    ".no"
                                                ),
                                              },
                                              domProps: {
                                                value: _vm.newPurchaseNumber,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.newPurchaseNumber =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.numberType ===
                                                    _vm.PROJECT_TYPES.CONTRACT,
                                                  expression:
                                                    "numberType === PROJECT_TYPES.CONTRACT",
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.newPurchaseRevision,
                                                  expression:
                                                    "newPurchaseRevision",
                                                },
                                              ],
                                              staticClass:
                                                "related-project-revision-input",
                                              class: {
                                                "error-highlight":
                                                  _vm.isInvalidNumber,
                                              },
                                              attrs: {
                                                id: "related-project-revision-input",
                                                type: "text",
                                                placeholder: _vm.$t("revision"),
                                              },
                                              domProps: {
                                                value: _vm.newPurchaseRevision,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.newPurchaseRevision =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass: "fa fa-lg fa-plus",
                                              on: {
                                                click: function () {
                                                  return _vm.attachRelated()
                                                },
                                              },
                                            }),
                                          ],
                                          2
                                        )
                                      : _c("div", [
                                          _c(
                                            "p",
                                            [
                                              _vm.deep(
                                                _vm.currentProject,
                                                "relatedProjects.length"
                                              )
                                                ? [
                                                    _vm._l(
                                                      _vm.relatedProjects,
                                                      function (item) {
                                                        return [
                                                          !!item.relatedProjectId
                                                            ? _c(
                                                                "router-link",
                                                                {
                                                                  key: item.id,
                                                                  staticClass:
                                                                    "related-link",
                                                                  attrs: {
                                                                    to: {
                                                                      name: _vm.navToRouterName,
                                                                      params: {
                                                                        id: item.relatedProjectId,
                                                                        prev: _vm.currentRouteName,
                                                                      },
                                                                    },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.getRelatedProjectsNumber(
                                                                          item
                                                                        )
                                                                      ) +
                                                                      ";\n                          "
                                                                  ),
                                                                ]
                                                              )
                                                            : [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.getRelatedProjectsNumber(
                                                                        item
                                                                      )
                                                                    ) +
                                                                    ";\n                          "
                                                                ),
                                                              ],
                                                        ]
                                                      }
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t("emptyValue")
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ],
                                              _vm._v(" "),
                                              _vm.isPicView &&
                                              !_vm.isEditRelated
                                                ? _c("a", {
                                                    staticClass:
                                                      "fa fa-pencil icon",
                                                    attrs: {
                                                      id: "modules-projects-detail-edit-related",
                                                    },
                                                    on: {
                                                      click: function () {
                                                        return _vm.enableEditRelated()
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row project-info-block" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "small-2 medium-2 large-2" },
                                    [
                                      _c("label", { staticClass: "emphasis" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("project.purchaseOrder.site")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("pre", [
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.purchase.siteId)),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.buildingIncludedRequired
                                    ? _c(
                                        "div",
                                        {
                                          ref: "buildingIncludedRef",
                                          staticClass:
                                            "small-10 medium-10 large-10",
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "emphasis" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "project.purchaseOrder.buildingIncluded"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.isEditBuildingIncluded
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "building-included",
                                                },
                                                [
                                                  _c("HKLMultiSelect", {
                                                    attrs: {
                                                      options:
                                                        _vm.buildingHklOptions,
                                                      value:
                                                        _vm.selectedBuildingIds,
                                                      respectOptionDisabled: true,
                                                      showSearch: false,
                                                      optionLabelProp: "label",
                                                      placeholder: "",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.onBuildingIncludedChange,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c("div", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "building-included-content",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.buildingIncludedDisplay
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                    _vm.showBuildingIncludedEditIcon
                                                      ? _c("a", {
                                                          staticClass:
                                                            "fa fa-pencil icon",
                                                          on: {
                                                            click: function () {
                                                              return _vm.enableEditBuildingIncluded()
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isOpen || _vm.retention.percentValue > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "small-12 project-retention-wrapper",
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "emphasis" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "project.retention.label"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.allowEditRetention &&
                                          _vm.isEditRetention
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "project-retention",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.retention
                                                            .percentValue,
                                                        expression:
                                                          "retention.percentValue",
                                                      },
                                                      {
                                                        name: "fusioninputcheck",
                                                        rawName:
                                                          "v-fusioninputcheck",
                                                        value: {
                                                          type: "integer",
                                                          pattern: function (
                                                            val
                                                          ) {
                                                            var value =
                                                              Number(
                                                                val || ""
                                                              ) || 0
                                                            return (
                                                              value >= 0 &&
                                                              value <= 100
                                                            )
                                                          },
                                                        },
                                                        expression:
                                                          "{\n                        type: 'integer',\n                        pattern: (val) => {\n                          const value = Number(val || '') || 0\n                          return (value >= 0) && (value <= 100)\n                        }\n                      }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "project-retention-input",
                                                    attrs: {
                                                      id: "project-retention-input",
                                                      type: "text",
                                                      novalidate: "",
                                                      autofocus: "",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.retention
                                                          .percentValue,
                                                    },
                                                    on: {
                                                      focusout: function () {
                                                        return _vm.updateRetention()
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.retention,
                                                          "percentValue",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [_vm._v("%")]),
                                                ]
                                              )
                                            : _c("div", [
                                                _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      dblclick: function () {
                                                        return _vm.editRetention()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.allowEditRetention &&
                                                            !_vm.retention
                                                              .percentValue
                                                            ? _vm.$t(
                                                                "emptyValue"
                                                              )
                                                            : (_vm.retention
                                                                .percentValue ||
                                                                "0") + "%"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                    _vm.allowEditRetention
                                                      ? _c("a", {
                                                          staticClass:
                                                            "fa fa-pencil icon",
                                                          attrs: {
                                                            id: "modules-projects-detail-edit-retention",
                                                          },
                                                          on: {
                                                            click: function () {
                                                              return (_vm.isEditRetention = true)
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "project-retention-amount",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("equivalentTo")
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm._f("formatCurrency")(
                                                      _vm.retentionAmount,
                                                      {
                                                        force: true,
                                                        currencyCode:
                                                          _vm.currencyCode,
                                                      }
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "PencilEdit",
                                    {
                                      staticClass: "small-12",
                                      attrs: {
                                        fieldLabel: _vm.$t(
                                          "project.actualCommDate.label"
                                        ),
                                        displayValue:
                                          _vm.actualCommDateFieldTools
                                            .displayField.value,
                                        canEdit:
                                          _vm.actualCommDateFieldTools.canEdit
                                            .value,
                                      },
                                      on: {
                                        openPencil:
                                          _vm.actualCommDateFieldTools
                                            .initEditBoxValue,
                                        closePencil:
                                          _vm.actualCommDateFieldTools.updateFc,
                                      },
                                    },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          calendarButton: true,
                                          calendarButtonIcon: "fa fa-calendar",
                                          value: _vm.formatDate(
                                            _vm.actualCommDateFieldTools
                                              .pendingField.value
                                          ),
                                        },
                                        on: {
                                          selected: function (val) {
                                            return _vm.actualCommDateFieldTools.setPendingField(
                                              val
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "PencilEdit",
                                    {
                                      staticClass: "small-12",
                                      attrs: {
                                        fieldLabel: _vm.$t(
                                          "project.actualCompDate.label"
                                        ),
                                        displayValue:
                                          _vm.actualCompDateFieldTools
                                            .displayField.value,
                                        canEdit:
                                          _vm.actualCompDateFieldTools.canEdit
                                            .value,
                                      },
                                      on: {
                                        openPencil:
                                          _vm.actualCompDateFieldTools
                                            .initEditBoxValue,
                                        closePencil:
                                          _vm.actualCompDateFieldTools.updateFc,
                                      },
                                    },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          calendarButton: true,
                                          calendarButtonIcon: "fa fa-calendar",
                                          value: _vm.formatDate(
                                            _vm.actualCompDateFieldTools
                                              .pendingField.value
                                          ),
                                        },
                                        on: {
                                          selected: function (val) {
                                            return _vm.actualCompDateFieldTools.setPendingField(
                                              val
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("DlpDateField", {
                                    staticClass: "small-12",
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "PencilEdit",
                                  {
                                    staticClass: "small-12 project-remark",
                                    attrs: {
                                      fieldLabel: _vm.$t(
                                        "project.remarks.label"
                                      ),
                                      canEdit:
                                        _vm.remarksFieldTools.canEdit.value,
                                    },
                                    on: {
                                      openPencil:
                                        _vm.remarksFieldTools.initEditBoxValue,
                                      closePencil:
                                        _vm.remarksFieldTools.updateFc,
                                    },
                                  },
                                  [
                                    _c("TextField", {
                                      attrs: {
                                        dirtyCheck: false,
                                        value:
                                          _vm.remarksFieldTools.pendingField
                                            .value,
                                      },
                                      on: {
                                        inputValue:
                                          _vm.remarksFieldTools.setPendingField,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "pre",
                                      {
                                        attrs: { slot: "display-show" },
                                        slot: "display-show",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.remarksFieldTools.displayField
                                              .value
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showProjectRepTable ? _c("ProjectRepresentative") : _vm._e(),
          _vm._v(" "),
          _vm.canProjectAccess
            ? _c("div", { staticClass: "project-po-attachment-wrapper" }, [
                _c(
                  "ul",
                  {
                    staticClass: "accordion accordion-customize",
                    attrs: {
                      id: "project-po-attachment",
                      "data-accordion": "",
                      "data-deep-link": "true",
                      "data-allow-all-closed": "true",
                      "data-multi-expand": "true",
                      "data-update-history": "true",
                      "data-deep-link-smudge": "500",
                    },
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "accordion-item is-active",
                        attrs: { "data-accordion-item": "" },
                      },
                      [
                        _c("a", { staticClass: "accordion-title" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("project.projectDocs"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "accordion-content",
                            attrs: { "data-tab-content": "" },
                          },
                          [
                            _c("AttachedPo", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.tenderDerived || _vm.poResourceId,
                                  expression: "tenderDerived || poResourceId",
                                },
                              ],
                              attrs: {
                                isTender: false,
                                purchase: _vm.purchase,
                                numberType: _vm.numberType,
                                purchaseNumbers: [_vm.poNumber],
                                resourceIdMap: _vm.resourceIdMap,
                                awardedDate: _vm.awardedDate,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm.isEditDesc
                                ? _c(
                                    "div",
                                    { staticClass: "project-docs-desc" },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.guidelineDesc,
                                            expression: "guidelineDesc",
                                          },
                                          {
                                            name: "autosize",
                                            rawName: "v-autosize",
                                          },
                                        ],
                                        ref: "docDesc",
                                        staticClass: "autosize",
                                        attrs: {
                                          id: "project-guideline-docs-desc",
                                          type: "text",
                                          autofocus: "",
                                        },
                                        domProps: { value: _vm.guidelineDesc },
                                        on: {
                                          focusout: function () {
                                            return _vm.updateDescription()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.guidelineDesc =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "project-docs-desc-hint",
                                        },
                                        [
                                          _c("popover", {
                                            attrs: {
                                              text: _vm.$t(
                                                "project.projectDocsHint"
                                              ),
                                              position: "bottom-left",
                                              width: 500,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c("div", [
                                    _vm.isPicView || _vm.guidelineDesc
                                      ? _c(
                                          "pre",
                                          {
                                            on: {
                                              dblclick: function ($event) {
                                                return _vm.dblClickEdit()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.guidelineDesc ||
                                                  (_vm.isPicView && _vm.isOpen
                                                    ? _vm.$t(
                                                        "project.docs.fillDescHint"
                                                      )
                                                    : "")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isPicView && _vm.isOpen
                                      ? _c("i", {
                                          staticClass: "fa fa-pencil icon",
                                          on: { click: _vm.dblClickEdit },
                                        })
                                      : _vm._e(),
                                  ]),
                            ]),
                            _vm._v(" "),
                            (
                              _vm.isCompleted
                                ? _vm.isPicView
                                : _vm.isPicView && _vm.isOpen
                            )
                              ? _c("HkldDropzone", {
                                  attrs: {
                                    sourceId: _vm.projectId,
                                    action: _vm.getCreateDocAction(),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("EditAttachments", {
                              attrs: {
                                sourceId: _vm.projectId,
                                canEdit: _vm.isCompleted
                                  ? _vm.isPicView
                                  : _vm.isPicView && _vm.isOpen,
                                canDelete: _vm.isPicView && _vm.isOpen,
                                canDownloadAll:
                                  _vm.isProjectRepresentative ||
                                  (_vm.isContractor && !_vm.showInviteBtn),
                                action: _vm.getDeleteDocAction(),
                                zipName:
                                  _vm.currentProject.number +
                                  "_Project_Documents.zip",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tabs-container-wrapper" },
            [
              _c(
                "TabsContainer",
                {
                  key: _vm.projectId,
                  ref: "tabs-container",
                  staticClass: "tabs-container",
                  attrs: { tabNames: _vm.tabNames },
                },
                [
                  _vm.isUnderBatch
                    ? _c("template", { slot: "float-right" }, [
                        _c(
                          "i",
                          {
                            staticClass:
                              "batch-review-nav__link show-only-while-sticky-header-on",
                            class: {
                              "batch-review-nav__link--disabled":
                                !_vm.canGoToPreviousWorkPermitRecord,
                            },
                            on: { click: _vm.toPreviousWorkPermit },
                          },
                          [
                            _vm._v(
                              "\n            < " +
                                _vm._s(
                                  _vm.$t("listNavigation.previousRecord")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass:
                              "batch-review-nav__link show-only-while-sticky-header-on",
                            class: {
                              "batch-review-nav__link--disabled":
                                !_vm.canGoToNextWorkPermitRecord,
                            },
                            on: { click: _vm.toNextWorkPermit },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("listNavigation.nextRecord")) +
                                " >\n          "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDocIconForUser
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-new-doc",
                          attrs: { slot: "icon-1" },
                          slot: "icon-1",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenantProjects.docs")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("SubmissionAccordion", {
                    attrs: { slot: "tab-0" },
                    slot: "tab-0",
                  }),
                  _vm._v(" "),
                  _c("Documents", { attrs: { slot: "tab-1" }, slot: "tab-1" }),
                  _vm._v(" "),
                  _vm.enableWorkPermitsFeature
                    ? _c("ContractorInfo", {
                        attrs: { slot: "tab-2" },
                        slot: "tab-2",
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableWorkPermitsFeature
                    ? _c("WorkPermitView", {
                        ref: "work-permit-view",
                        attrs: { slot: "tab-3" },
                        slot: "tab-3",
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-deduction-modal", {
        ref: "addDeductionModal",
        attrs: { editable: _vm.isPicView && _vm.isOpen },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }